import { Card, Grid2, Skeleton, Typography } from "@mui/material";

interface Props {
  data: any;
  isLoading: boolean;
}

const detailFields = [
  { name: "SEBI Number", key: "sebiNumber" },
  { name: "GST", key: "gst" },
  { name: "Address", key: "address" },
  { name: "Country", key: "country" },
  { name: "State", key: "state" },
  { name: "City", key: "city" },
  { name: "Pincode", key: "pincode" },
];

const Details = (props: Props) => {
  const { data, isLoading } = props;

  return (
    <Grid2 container spacing={2.5} padding={2}>
      {detailFields.map((field) => (
        <Grid2 size={4} key={field.key}>
          <Card
            sx={{
              padding: 2,
              height: "100%",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <Typography
              fontSize={16}
              fontWeight={500}
              color={"var(--grey-700)"}
            >
              {field.name}
            </Typography>
            <Typography
              fontSize={16}
              fontWeight={700}
              color={"var(--primary-900)"}
              marginTop={1}
              sx={{ wordBreak: "break-word" }}
            >
              {isLoading ? <Skeleton /> : data?.[field.key] || "-"}
            </Typography>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default Details;
